module.exports = __webpack_public_path__ + "img/header-login.85a33a5e.jpg";